export const Sortable = (superclass) => class extends superclass {
  dragStart (e) {
    this._dragSrc = e.currentTarget
    e.dataTransfer.effectAllowed = 'move'
    e.dataTransfer.setData('text/plain', '')

    const image = this.dragImageFor?.(e.currentTarget)
    if (image) {
      const { left, top } = image.getBoundingClientRect()
      e.dataTransfer.setDragImage(image, e.clientX - left, e.clientY - top)
    }

    window.requestAnimationFrame(() => this._dragSrc.classList.add('opacity-40'))
  }

  dragOver (e) {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'

    const target = e.currentTarget
    if (target === this._dragSrc) return

    this._clearDropIndicators()

    const { top, height } = target.getBoundingClientRect()
    const isAboveMiddle = e.clientY < top + height / 2
    target.classList.add(isAboveMiddle ? 'border-t-2' : 'border-b-2', 'border-blue-400')
  }

  dragLeave (e) {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      this._clearDropIndicators()
    }
  }

  drop (e) {
    e.preventDefault()

    const target = e.currentTarget
    if (!this._dragSrc || target === this._dragSrc) return

    this._clearDropIndicators()

    const { top, height } = target.getBoundingClientRect()
    const parent = target.parentNode

    if (e.clientY < top + height / 2) {
      parent.insertBefore(this._dragSrc, target)
    } else {
      parent.insertBefore(this._dragSrc, target.nextSibling)
    }
  }

  dragEnd () {
    const moved = this._dragSrc
    if (moved) moved.classList.remove('opacity-40')
    this._dragSrc = null
    this._clearDropIndicators()
    this.onDragEnd?.(moved)
  }

  _clearDropIndicators () {
    this.sortableItemTargets.forEach((el) => {
      el.classList.remove('border-t-2', 'border-b-2', 'border-blue-400')
    })
  }
}
